<template>
  <div>
    <v-row
      class="mt-5"
    >
      <v-col
        cols="12"
      >
        <section>
          <line-chart
            :raw-data="players"
            x-value="last_name"
            y-value-prefix="player_stats."
            :chart-value-keys="[{ key: 'TL', label: $t('variables.TL'), type: 'bar' }, { key: 'TG', label: 'RPE', type: 'line' }, { key: 'TTM', label: $t('variables.TTM'), type: 'line' }]"
            class="mb-5"
            :yaxis="[ { title: { text: $t('chart_legends.load')} }, { title: { text: 'RPE' }, opposite: true}, { title: { text: $t('variables.TTM')}, opposite: true}]"
            :markers="{colors: ['#00E396','#008FFB', '#FEB019']}"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: players.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.main_team_indicators') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col
        cols="4"
      >
        <section>
          <line-chart
            type="bar"
            :raw-data="enjoymentDistribution"
            x-value="key"
            :chart-value-keys="[{ key: 'value', label: $t('variables.ENJY'), type: 'bar' }]"
            :yaxis="[{ labels: {
              formatter: function(value) {
                return value.toFixed(2);
              }
            } }]"
            :colors="['#FF4560']"
            :xaxis="{
              labels: {
                rotate: -45
              },
              catergories: enjoymentDistribution.map(p => p.key),
              tickPlacement: 'on',
              title: { text: $t('variables.ENJY')}
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.enjoyment_distribution') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col
        cols="4"
      >
        <section>
          <line-chart
            type="bar"
            :raw-data="trainingGradeDistribution"
            x-value="key"
            :chart-value-keys="[{ key: 'value', label: $t('variables.TG'), type: 'bar' }]"
            :yaxis="[ {labels: {
              formatter: function(value) {
                return value.toFixed(2);
              }
            } }]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: trainingGradeDistribution.map(p => p.key),
              tickPlacement: 'on',
              tickAmount: 10,
              title: { text: $t('variables.TG')}
            }"
            :colors="['#00E396']"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.training_grade_distribution') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col
        cols="4"
      >
        <section class="fill-height">
          <team-pain-widget
            :event-stats="team"
          />
        </section>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart'
import TeamPainWidget from '@/components/training-load/TeamPainWidget.vue'
import { getColorForValue } from '@/utils/helpers'

export default {
  name: 'PerformanceRpeGraphs',
  components: { TeamPainWidget, LineChart },
  props: {
    players: {
      type: Array,
      required: true
    },
    team: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    labels: {}
  }),
  computed: {
    enjoymentDistribution() {
      if (!this.team.ENJY_dist) return []

      const data = [
        { key: 1, value: null },
        { key: 2, value: null },
        { key: 3, value: null },
        { key: 4, value: null },
        { key: 5, value: null }
      ]

      this.team.ENJY_dist.forEach((element) => {
        data.find(e => e.key === element.grade).value = element.value
      })

      return data
    },
    trainingGradeDistribution() {
      if (!this.team.TG_dist) return []

      const data = [
        { key: 1, value: null },
        { key: 1.5, value: null },
        { key: 2, value: null },
        { key: 2.5, value: null },
        { key: 3, value: null },
        { key: 3.5, value: null },
        { key: 4, value: null },
        { key: 4.5, value: null },
        { key: 5, value: null },
        { key: 5.5, value: null },
        { key: 6, value: null },
        { key: 6.5, value: null },
        { key: 7, value: null },
        { key: 7.5, value: null },
        { key: 8, value: null },
        { key: 8.5, value: null },
        { key: 9, value: null },
        { key: 9.5, value: null },
        { key: 10, value: null }
      ]

      this.team.TG_dist.forEach((element) => {
        data.find(e => e.key === element.grade).value = element.value
      })

      return data
    }
  },
  created() {
  },
  methods: {
    getColorForValue

  }
}
</script>

<style scoped>

</style>
